'use client'
import React, { ReactNode } from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'
import './styles.scss'

interface FAQProps {
  faqData: { answer: string | ReactNode; question: string }[]
}
const FAQ: React.FC<FAQProps> = ({ faqData }) => {
  const t = useTranslations('translation')

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{t('faq')}</div>
      <div className={styles.container}>
        <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
          {faqData?.map((item, idx) => {
            return (
              <AccordionItem key={`accordion_questions_${idx}`}>
                <div className="faqHead">
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <span>{item.question}</span>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                </div>
                <AccordionItemPanel>
                  <div className={styles.answer}>{item.answer}</div>
                </AccordionItemPanel>
              </AccordionItem>
            )
          })}
        </Accordion>
      </div>
    </div>
  )
}

export default React.memo(FAQ)
